(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1922);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 1 modules
var stitches = __webpack_require__(6567);
;// CONCATENATED MODULE: ./src/components/global/Button/styles.ts

var ButtonBase = (0,stitches/* styled */.zo)("button", {
    width: "100%",
    height: "40px",
    color: "$white-100",
    backgroundColor: "$secondary-500",
    borderRadius: "$lg",
    border: "none",
    "&:hover": {
        backgroundColor: "$secondary-400"
    },
    "&[disabled]": {
        // opacity: 0.5,
        cursor: "not-allowed"
    },
    variants: {
        // disabled: {
        //   true: {
        //     backgroundColor: '$primary100',
        //   },
        // },
        isSubmiting: {
            true: {
                opacity: 0.8,
                cursor: "not-allowed",
                "&:hover": {
                    backgroundColor: "$secondary-500"
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/components/global/Button/index.tsx






function Button(_param) {
    var label = _param.label, isSubmiting = _param.isSubmiting, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "isSubmiting"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        disabled: isSubmiting,
        isSubmiting: isSubmiting,
        children: isSubmiting ? "Carregando..." : label
    }));
}


/***/ }),

/***/ 5453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ VerticalLine; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);





function VerticalLine(_param) {
    var _color = _param.color, color = _color === void 0 ? "#979797" : _color, _height = _param.height, height = _height === void 0 ? "100%" : _height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "color",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
            height: height,
            backgroundColor: color,
            width: "2px"
        })
    });
}


/***/ }),

/***/ 1922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 1 modules
var stitches = __webpack_require__(6567);
;// CONCATENATED MODULE: ./src/components/pages/SignIn/FloatBox/styles.ts

var Box = (0,stitches/* styled */.zo)("div", {
    background: "#FFF",
    borderRadius: "$lg",
    padding: "$7",
    fontSize: "6xl",
    fontWeight: "$bold",
    width: "200px",
    height: "fit-content"
});

;// CONCATENATED MODULE: ./src/components/pages/SignIn/FloatBox/index.tsx



function FloatBox() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
        children: "Desenvolva OEDs de forma simples e acess\xedvel"
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
;// CONCATENATED MODULE: ./src/components/pages/SignIn/Form/styles.ts

var Container = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "#FFF",
    display: "flex",
    flexDirection: "column",
    width: "510px",
    borderRadius: "$lg",
    padding: "$15 1.875rem"
});
var FormArea = (0,stitches/* styled */.zo)("form", {
    padding: "0 $14",
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    div: {
        width: "100%",
        display: "flex",
        position: "relative"
    },
    p: {
        fontSize: "3.125rem",
        color: "$black-100",
        fontWeight: "$semiBold",
        marginBottom: "$8"
    },
    "@md": {
        padding: "0 $4"
    }
});
var Link = (0,stitches/* styled */.zo)("a", {
    textDecoration: "none !important",
    cursor: "pointer",
    color: "$primary-500",
    width: "fit-content"
});
var LogoArea = (0,stitches/* styled */.zo)("div", {
    width: "100%",
    display: "flex",
    alignItems: "center"
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/global/VerticalLine/index.tsx
var VerticalLine = __webpack_require__(5453);
// EXTERNAL MODULE: ./src/components/global/Button/index.tsx + 1 modules
var Button = __webpack_require__(8690);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(6310);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(7533);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var bs_index_esm = __webpack_require__(3750);
;// CONCATENATED MODULE: ./src/components/global/InputWithValidation/styles.ts

var InputGroup = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    marginBottom: "$4",
    $$btnSize: "3.375rem",
    strong: {
        color: "$errorMessage",
        fontWeight: "$medium",
        fontSize: "$xs",
        marginLeft: "$4"
    },
    button: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: "$4",
        border: 0,
        background: "transparent",
        height: "$$btnSize",
        display: "flex",
        alignItems: "center",
        svg: {
            color: "#B7B7B7"
        }
    }
});
var Input = (0,stitches/* styled */.zo)("input", {
    height: "$$btnSize",
    width: "100%",
    backgroundColor: "$gray-100",
    color: "#000",
    fontSize: "$md",
    borderRadius: "$lg",
    border: "none",
    padding: "$4",
    outline: "none",
    "&:focus-visible": {
        border: "1px solid $primary-500"
    },
    variants: {
        isInvalid: {
            true: {
                border: "1px solid $errorMessage"
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/components/global/InputWithValidation/index.tsx







var InputWithValidationBase = function(_param, ref) {
    var errorMessage = _param.errorMessage, props = (0,_object_without_properties/* default */.Z)(_param, [
        "errorMessage"
    ]);
    var isPassword = props.type === "password";
    var _$ref = (0,react.useState)(isPassword), hiddenPassword = _$ref[0], setHiddenPassword = _$ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: ref
            }, props), {
                type: hiddenPassword ? "password" : "text",
                isInvalid: !!errorMessage
            })),
            !!isPassword && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setHiddenPassword(!hiddenPassword);
                },
                children: hiddenPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsEye */.rCC, {
                    size: "24"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(bs_index_esm/* BsEyeSlash */.I$m, {
                    size: "24"
                })
            }),
            !!errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: errorMessage
            })
        ]
    });
};
/* harmony default export */ var InputWithValidation = (/*#__PURE__*/(0,react.forwardRef)(InputWithValidationBase));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
;// CONCATENATED MODULE: ./src/components/pages/SignIn/Form/index.tsx


















var LoginFormValidation = index_esm/* object */.Ry().shape({
    password: index_esm/* string */.Z_().required("Digite sua senha!"),
    email: index_esm/* string */.Z_().email().required("Informe seu e-mail")
});
function SignInForm() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    function submit(data) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0,_async_to_generator/* default */.Z)(function(data) {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/login", {
                                email: data.email,
                                password: data.password
                            })
                        ];
                    case 2:
                        _state.sent();
                        router.push("/home");
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (error.response.status === 401) {
                            (0,react_toastify_esm/* toast */.Am)("Erro ao fazer login. Email ou senha incorreto.", {
                                type: "error"
                            });
                        } else {
                            (0,react_toastify_esm/* toast */.Am)("Houve um erro ao fazer login. Tente novamente mais tarde.", {
                                type: "error"
                            });
                        }
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    var ref3 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(LoginFormValidation)
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/nextOED.svg",
                        width: 151,
                        height: 52
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine/* default */.Z, {
                        margin: "0 20px",
                        height: "80%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/dorina.svg",
                        width: 105,
                        height: 53
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormArea, {
                onSubmit: handleSubmit(submit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Login"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithValidation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email")), {
                        title: "Email",
                        type: "email",
                        placeholder: "E-mail",
                        errorMessage: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputWithValidation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("password")), {
                            title: "Senha",
                            type: "password",
                            placeholder: "Senha",
                            errorMessage: (ref1 = errors.password) === null || ref1 === void 0 ? void 0 : ref1.message
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        prefetch: false,
                        passHref: true,
                        href: "/esqueci-minha-senha",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                            children: "Esqueceu sua senha?"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginTop: "3rem"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            isSubmiting: isLoading,
                            type: "submit",
                            label: isLoading ? "carregando..." : "Login"
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/styles/pages/signIn/index.ts

var signIn_Container = (0,stitches/* styled */.zo)("div", {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    position: "relative",
    background: "$white-100"
});
var SubContainer = (0,stitches/* styled */.zo)("div", {
    margin: "0 auto",
    padding: "$5",
    width: "100%",
    minHeight: "100vh",
    maxWidth: "90rem",
    "@md": {
        padding: "0"
    }
});
var Wrapper = (0,stitches/* styled */.zo)("div", {
    width: "100%",
    display: "flex",
    minHeight: "100%",
    padding: "1.875rem",
    borderRadius: "$md",
    backgroundImage: "url(/images/login_background.svg)",
    backgroundSize: "cover",
    "@md": {
        borderRadius: "0",
        padding: "$4",
        justifyContent: "center"
    }
});
var PinsContainer = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    paddingLeft: "$6",
    flex: "1",
    "@md": {
        display: "none"
    }
});
var PinsSubcontainer = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "80%",
    height: "100%",
    "@lg": {
        width: "100%"
    }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/index.tsx






var __N_SSP = true;
function Home() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(signIn_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "NextOED - Login"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PinsContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PinsSubcontainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatBox, {})
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 8357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,2964,7533,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);